"use client";

import styles from "@/styles/product-detail/similar-product.module.scss";
import Image from "next/image";
import Link from 'next/link'
import { ProductType } from "@/types/product";
import { useState, useEffect } from "react";
import productApi from "@/service/modules/productApi";


interface Props {
  productId: number | string;
}
export default function ProductSimilar({ productId }: Props) {
  const [relatedProducts, setRelatedProducts] = useState<ProductType[]>([]);

  useEffect(() => {
    getRelatedProducts();
  }, []);

  const getRelatedProducts = async () => {
    try {
      const res = await productApi.getProductScreen(productId);
      if (res && res.data && res.data.relatedProducts && res.data.relatedProducts.length) {
        setRelatedProducts(res.data.relatedProducts);
      }
    } catch {
      console.log('relatedProducts fetch error');
    }
  };

  return (
    <>
      {
        relatedProducts && relatedProducts.length ? (
          <div className={styles["comp-similar-product"]}>
            <div className={styles["content"]}>
              <div className={styles["title"]}>Check out these similar items</div>

              <div className={styles["product-list"]}>
                {
                  relatedProducts.map((item: ProductType) => (
                    <Link href={item.url || ''} key={item.productID} className={styles['product-item']}> 
                      <div>
                        <Image
                          className={styles['goods-image']}
                          src={item.newThumbnail || item.filename}
                          alt={item.name}
                          width={88}
                          height={88}
                        />
                        <div className={styles['price']}>
                          {item.price ? `$${item.price}` : null}
                        </div>
                        <div className={styles['normal-price']}>
                          {item.normalPrice ? `$${item.normalPrice}` : null}
                        </div>
                      </div>
                    </Link>
                  ))
                }
              </div>
            </div>
          </div>
        ) : null
      }
    </>
  );
}
